import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Center, factory, Group, Stack, useProps, useStyles } from '@coveord/plasma-mantine';
import { Children } from 'react';
import classes from './EmptyState.module.css';
import { EmptyStateActions } from './EmptyStateActions.js';
import { EmptyStateBody } from './EmptyStateBody.js';
import { EmptyStateProvider } from './EmptyStateContext.js';
import { EmptyStateImage } from './EmptyStateImage.js';
import { EmptyStateLink } from './EmptyStateLink.js';
import { EmptyStateTitle } from './EmptyStateTitle.js';
import { PrerequisitesList } from '../prerequisites-list/PrerequisitesList.js';
import { PrerequisitesListItem } from '../prerequisites-list/PrerequisitesListItem.js';
var defaultProps = {
    variant: 'first-use'
};
export var EmptyState = factory(function(props) {
    var _useProps = useProps('EmptyState', defaultProps, props), variant = _useProps.variant, children = _useProps.children, style = _useProps.style, className = _useProps.className, classNames = _useProps.classNames, styles = _useProps.styles, unstyled = _useProps.unstyled, ref = _useProps.ref, others = _object_without_properties(_useProps, [
        "variant",
        "children",
        "style",
        "className",
        "classNames",
        "styles",
        "unstyled",
        "ref"
    ]);
    var getStyles = useStyles({
        name: 'EmptyState',
        classes: classes,
        props: props,
        className: className,
        style: style,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
    });
    var childrenArray = Children.toArray(children);
    var actions = childrenArray.find(function(child) {
        return child.type === EmptyStateActions;
    });
    var links = childrenArray.filter(function(child) {
        return child.type === EmptyStateLink;
    });
    var image = childrenArray.find(function(child) {
        return child.type === EmptyStateImage;
    });
    var title = childrenArray.find(function(child) {
        return child.type === EmptyStateTitle;
    });
    var body = childrenArray.find(function(child) {
        return child.type === EmptyStateBody;
    });
    var prerequisitesList = childrenArray.find(function(child) {
        return child.type === PrerequisitesList;
    });
    if (variant === 'small') {
        return /*#__PURE__*/ _jsx(EmptyStateProvider, {
            value: {
                variant: variant,
                getStyles: getStyles
            },
            children: /*#__PURE__*/ _jsx(Center, {
                flex: 1,
                children: /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({
                    ref: ref,
                    variant: variant,
                    gap: "sm",
                    p: "lg"
                }, others, getStyles('root')), {
                    w: "100%",
                    maw: 480,
                    children: [
                        /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({}, getStyles('container')), {
                            gap: "xs",
                            children: [
                                image,
                                title,
                                body
                            ]
                        })),
                        links,
                        actions
                    ]
                }))
            })
        });
    }
    return /*#__PURE__*/ _jsx(EmptyStateProvider, {
        value: {
            variant: variant,
            getStyles: getStyles
        },
        children: /*#__PURE__*/ _jsx(Center, {
            flex: 1,
            children: /*#__PURE__*/ _jsxs(Group, _object_spread_props(_object_spread({
                ref: ref,
                p: "lg",
                wrap: "nowrap",
                gap: "xl",
                variant: variant
            }, others, getStyles('root')), {
                children: [
                    /*#__PURE__*/ _jsxs(Stack, _object_spread_props(_object_spread({}, getStyles('container')), {
                        gap: "lg",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ _jsxs(Stack, {
                                gap: "xs",
                                children: [
                                    title,
                                    body
                                ]
                            }),
                            prerequisitesList,
                            links.length ? /*#__PURE__*/ _jsx(Stack, {
                                gap: "xs",
                                children: links
                            }) : null,
                            actions
                        ]
                    })),
                    image
                ]
            }))
        })
    });
});
EmptyState.Actions = EmptyStateActions;
EmptyState.Title = EmptyStateTitle;
EmptyState.Body = EmptyStateBody;
EmptyState.Link = EmptyStateLink;
EmptyState.Image = EmptyStateImage;
EmptyState.PrerequisiteList = PrerequisitesList;
EmptyState.PrerequisiteListItem = PrerequisitesListItem;
EmptyState.displayName = 'EmptyState';

//# sourceMappingURL=EmptyState.js.map